// extracted by mini-css-extract-plugin
module.exports = {"infobanner":"static-infobanner_infobanner__FrEI3"};